export default __webpack_public_path__ + "static/media/card-futuristic-quadratic.1c57b0b0.svg";